export function SlashMenu({children}) {
    return (
        <div data-kg-slash-menu>
            {children}
        </div>
    );
}
